import React from 'react';
import { AlertTriangle, RefreshCw, Home } from 'lucide-react';

const isChunkError = (e) => /ChunkLoadError|Loading chunk|Loading CSS chunk|Failed to fetch dynamically imported module|Importing a module script failed/i.test(`${e?.name} ${e?.message}`);

// Hibahatár: egy komponens-hiba ne fehérítse ki az egész appot. Deploy utáni chunk-hiba → egyszeri automatikus újratöltés.
export default class ErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { error: null }; }
  static getDerivedStateFromError(error) { return { error }; }
  componentDidCatch(error, info) {
    if (isChunkError(error)) {
      const key = 'acx_chunk_reload';
      if (!sessionStorage.getItem(key)) { sessionStorage.setItem(key, String(Date.now())); window.location.reload(); return; }
    }
    try {
      const { API_URL } = require('../utils/api');
      fetch(`${API_URL}/api/error-logs/track`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'include',
        body: JSON.stringify({ source: 'frontend', severity: 'critical', error_type: error?.name || 'RenderError', error_message: String(error?.message || error).slice(0, 1000), stack_trace: String(info?.componentStack || '').slice(0, 4000), path: window.location.pathname }) }).catch(() => {});
    } catch { /* */ }
  }
  componentDidUpdate(prev) { if (this.state.error && prev.resetKey !== this.props.resetKey) this.setState({ error: null }); }
  render() {
    const { error } = this.state;
    if (!error) return this.props.children;
    const chunk = isChunkError(error);
    return (
      <div className={`${this.props.full ? 'min-h-screen' : 'min-h-[50vh]'} flex items-center justify-center p-6`} data-testid="error-boundary">
        <div className="max-w-md w-full rounded-2xl border bg-white p-6 space-y-3 shadow-sm" style={{ borderColor: '#FECACA' }}>
          <div className="flex items-center gap-3"><span className="w-10 h-10 rounded-xl bg-red-50 text-red-600 flex items-center justify-center"><AlertTriangle size={18} /></span>
            <div><p className="font-heading text-base font-semibold text-slate-800">{chunk ? 'Új verzió érhető el' : 'Ez a rész most nem tölthető be'}</p>
              <p className="text-xs text-slate-500">{chunk ? 'Az alkalmazás frissült — töltsd újra az oldalt.' : 'A hiba naplózva. Az app többi része tovább működik.'}</p></div></div>
          {!chunk && <p className="text-[11px] font-mono text-slate-500 bg-slate-50 rounded-lg px-2 py-1.5 break-all" data-testid="error-boundary-message">{String(error?.message || error).slice(0, 200)}</p>}
          <div className="flex gap-2">
            <button type="button" onClick={() => window.location.reload()} className="inline-flex items-center gap-1.5 px-4 h-10 rounded-xl text-sm font-semibold text-white" style={{ background: '#B85A26' }} data-testid="error-boundary-reload"><RefreshCw size={14} /> Újratöltés</button>
            {!this.props.full && <button type="button" onClick={() => this.setState({ error: null })} className="px-4 h-10 rounded-xl text-sm border border-slate-200" data-testid="error-boundary-retry">Újrapróbálás</button>}
            <a href="/" className="inline-flex items-center gap-1.5 px-4 h-10 rounded-xl text-sm border border-slate-200 ml-auto"><Home size={14} /> Kezdőlap</a>
          </div>
        </div>
      </div>
    );
  }
}
